import { render } from "./com_caja.vue?vue&type=template&id=0777b31a&scoped=true"
import script from "./com_caja.vue?vue&type=script&lang=js"
export * from "./com_caja.vue?vue&type=script&lang=js"

import "./com_caja.vue?vue&type=style&index=0&id=0777b31a&lang=scss&scoped=true"
import "./com_caja.vue?vue&type=style&index=1&id=0777b31a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0777b31a"]])

export default __exports__